import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BreefInviteTrackingSummary } from "../../redux/slices/BreefInviteSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: "bold",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const TableWrapper = styled(TableContainer)({
  margin: "auto",
  marginTop: "1%",
  width: "90%",
}) as typeof TableContainer;

interface BreefTrackingTableProps {
  results: BreefInviteTrackingSummary[];
}

const BreefTrackingTable: React.FC<BreefTrackingTableProps> = ({ results }) => {
  const navigate = useNavigate();

  return (
    <TableWrapper component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Breef Name
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Tenant
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Sent
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Failed
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Pending
            </StyledTableCell>
            <StyledTableCell sx={{ backgroundColor: "#ED670A" }} align="center">
              Actions
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.map((breef) => (
            <StyledTableRow key={breef.breefId}>
              <TableCell align="center">{breef.breefName}</TableCell>
              <TableCell align="center">
                <Box>{breef.tenantName}</Box>
                <Box sx={{ fontSize: "0.8em", color: "text.secondary" }}>
                  {breef.tenantEmail || breef.tenantPhone}
                </Box>
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.sentCount} color="success" size="small" />
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.failedCount} color="error" size="small" />
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.pendingCount} color="warning" size="small" />
              </TableCell>
              <TableCell align="center">
                <IconButton aria-label="view" onClick={() => navigate(`/breef-tracking/${breef.breefId}`)}>
                  <VisibilityIcon />
                </IconButton>
              </TableCell>
            </StyledTableRow>
          ))}
          {results.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No breefs found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};

export default BreefTrackingTable;
